import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, homeFor, useAuth } from "@/lib/auth";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Cases from "@/pages/Cases";
import CaseDetail from "@/pages/CaseDetail";
import Clients from "@/pages/Clients";
import Messages from "@/pages/Messages";
import Staff from "@/pages/Staff";
import Documents from "@/pages/Documents";
import Profile from "@/pages/Profile";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return <div className="grid min-h-screen place-items-center bg-page"><Loader2 className="animate-spin text-gold" /></div>;
  }
  return user ? children : <Navigate to="/login" replace />;
};

const Only = ({ roles, children }) => {
  const { user } = useAuth();
  return roles.includes(user.user_type) ? children : <Navigate to={homeFor(user)} replace />;
};

const Home = () => {
  const { user } = useAuth();
  return <Navigate to={user ? homeFor(user) : "/login"} replace />;
};

const TEAM = ["lawyer", "staff"];

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><AppShell /></Protected>}>
            <Route path="/dashboard" element={<Only roles={TEAM}><Dashboard /></Only>} />
            <Route path="/cases" element={<Cases />} />
            <Route path="/cases/:id" element={<CaseDetail />} />
            <Route path="/clients" element={<Only roles={TEAM}><Clients /></Only>} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/messages/:id" element={<Only roles={TEAM}><Messages /></Only>} />
            <Route path="/staff" element={<Only roles={["lawyer"]}><Staff /></Only>} />
            <Route path="/settings" element={<Only roles={TEAM}><Profile /></Only>} />
            <Route path="/documents" element={<Only roles={["client"]}><Documents /></Only>} />
            <Route path="/profile" element={<Only roles={["client"]}><Profile /></Only>} />
          </Route>
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
